
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulaminy-cenniki",
      function () {
        return require("private-next-pages/regulaminy-cenniki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulaminy-cenniki"])
      });
    }
  